import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as exportFileService from '../../../services/exportFile/exportFileService';

export const initializeExportDispatcher = createAsyncThunk('export/initializeExport', async (payload, thunkAPI) => {
    try {
        const result = await exportFileService.exportFile(payload);
        console.log("resultresultresultresult : ", result)
        if (result?.success) {
            return result?.message || "File initialization successfully. You will recieve mail";
        } else {
            return thunkAPI.rejectWithValue(result?.message || "Failed to initialize export. You don't have permission to export data in creditq");
        }
    } catch (err) {
        console.log("Error in initiatExportDispatcher : ", err);
        const msg = err?.response?.message || err?.message || "Internal Server Error!";
        return thunkAPI.rejectWithValue(msg)
    }
});

export const getDownloadFileLink = createAsyncThunk('exportFile/getDownloadLink', async (payload, thunkAPI) => {
    try {
        const result = await exportFileService.getExportFile(payload);
        console.log("result getDownloadFileLink : ", result)
        if (result?.success) {
            return result?.data || "File successfully fetch.";
        } else {
            return thunkAPI.rejectWithValue(result?.message || "Failed to download export file. You don't have permission to export data in creditq");
        }
    } catch (err) {
        console.log("Error in getDownloadFileLink : ", err);
        const msg = err?.response?.message || err?.message || "Internal Server Error!";
        return thunkAPI.rejectWithValue(msg)
    }
})

const initialState = {
    exportFileData: {
        loading: false,
        message: null,
        error: null,
    }
}


const exportFileSlice = createSlice({
    name: 'exportFile',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(initializeExportDispatcher.pending, (state) => {
            state.exportFileData.loading = true;
            state.exportFileData.error = null;
            state.exportFileData.message = null;
        })
            .addCase(initializeExportDispatcher.fulfilled, (state, action) => {
                state.exportFileData.loading = false;
                state.exportFileData.error = null;
                state.exportFileData.message = action.payload;
            })
            .addCase(initializeExportDispatcher.rejected, (state, action) => {
                state.exportFileData.loading = false;
                state.exportFileData.error = action.payload;
                state.exportFileData.message = null;
            })
    }
});

export const exportFileReducer = exportFileSlice.reducer;